<template>
	<div class="PostingModule-box">
		<div class="list_box">
			<el-form ref="form_base" :model="post_data" :rules="rules" label-position="left" label-width="120px">
				<div class="information_big_box">
					<div class="information_box">
						<div class="avatar" @click.stop="check_information(userinfo)">
							<img v-if="userinfo.avatar && userinfo.avatar!= ''" :src="userinfo.avatar" :alt="'TOZO Community ' + userinfo.nickname + ' User Avatar'"/>
							<i v-else class="el-icon-s-custom"></i>
						</div>
						<div class="content_box">
							<!-- <div class="custom-input" contenteditable="true" @input="handleInput" ref="autoFocusTextarea"></div> -->
							<!-- <div class="custom-input" @input="handleInput" ref="autoFocusTextarea" @focusout="clearIfNoInput" contenteditable="true" :value="post_data.content"></div> -->
							<textarea ref="autoFocusTextarea" aria-label="Post input" v-model="post_data.content" :placeholder="placeholder" rows="1" maxlength="1000" @input="adjustHeight" class="auto-expand-textarea"></textarea>
							<div class="topic_of_subjects" v-if="post_data.subjects && post_data.subjects.length > 0">
								<div class="subjects" v-for="(topic, index) in post_data.subjects" :key="topic">
									#{{ topic }}
								</div>
							</div>
						</div>
					</div>
				</div>

			  <div class="pics_and_videos" v-if="((post_data.pics && post_data.pics.length > 0) || (post_data.videos && post_data.videos.length > 0)) && post_data.post_type!= ''">
					<div class="file_box pics_box" v-if="post_data.pics && post_data.pics.length > 0 && post_data.post_type == 'pics'">
						<div class="file_item pics_item" v-for="(item_pics, index_pics) in post_data.pics" :key="index_pics" @click.stop="view_details(post_data.pics, 'pics')">
							<img :src="item_pics" :alt="'The TOZO community post contains a picture of ' + post_data.content" />
						</div>
					</div>
					<div class="file_box videos_box" v-if="post_data.videos && post_data.videos.length > 0 && post_data.post_type == 'videos'">
						<div class="file_item videos_item" v-for="(item_videos, index_videos) in post_data.videos" :key="index_videos" @click.stop="view_details(post_data.videos, 'videos')">
						  <video :src="item_videos" class="media-videos"></video>
						</div>
						<div class="file_item add_file_item" @click="add_post_videos()"><i class="el-icon-plus"></i></div>
					</div>
			  </div>

				<div class="bottom_box_big">
					<ImgUpload v-show="PicsFileUpload" ref="PicsUpload" :FileList="ImgList" :uploadType="post_data.post_type" :maxFileList="maxImgList" :acceptType="acceptType" @remove_imgs='remove_imgs' @save_imgs='save_imgs'></ImgUpload>
					<VideosUpload v-show="VideosFileUpload" ref="VideosUpload" :FileList="VideosList" :uploadType="post_data.post_type" :maxFileList="maxVideosList" :acceptType="acceptType" @remove_videos='remove_videos' @save_videos='save_videos'/></VideosUpload>
					
					<div class="PostingModule_bottom_box">
						<div class="bottom_box_icon">
						  <div class="icon_box" @click.stop="pics_fun()" :class="ImgList.length >= maxImgList ? 'no_drop' : 'pointer'">
								<img class="icon_box_img" src="../../assets/icon/picture.png" alt="TOZO community posts and uploads image icons"/>
								<!-- <i class="el-icon-picture-outline"></i> -->
						  </div>
						  <div class="icon_box" @click.stop="videos_fun()" :class="VideosList.length >= maxVideosList ? 'no_drop' : 'pointer'">
								<img class="icon_box_img" src="../../assets/icon/video.png" alt="TOZO community posts and uploads video icons"/>
								<!-- <i class="el-icon-video-camera-solid"></i> -->
						  </div>
						  <!-- <div class="icon_box" @click.stop="tags_fun()">
								<img class="icon_box_img" src="../../assets/icon/topic.png" alt="TOZO community posts topic icons"/>
						  </div> -->
						  <!-- <div class="icon_box" @click.stop="location_fun()">
								<img class="icon_box_img" src="../../assets/icon/place_blue.png" alt="TOZO community posts map location icons"/>
							 <div class="icon_box_text" v-if="post_data.location">{{ post_data.location }}</div>
						  </div> -->
						</div>
						<div class="btn_box">
							<button type="button" class="post_btn" :class="isSubmitting ? 'no_drop' : 'pointer'" :disabled="isSubmitting" @click="submitForm" >
								{{ isSubmitting ? $t('buttonArr.Submit') : $t('buttonArr.Submit') }}
							</button>
						  <!-- <div class="post_btn" @click="post_btn()">Post</div> -->
						</div>
					</div>
				</div>
			</el-form>

		</div>

		<viewDetailsBox
      v-if="viewDetailsShow"
      :viewDetailsShow="viewDetailsShow"
      :viewDetailsList="viewDetailsList"
      @update:viewDetailsShow="viewDetailsShow = $event"
      @update:viewDetailsList="viewDetailsList = $event"
		></viewDetailsBox>

	</div>
</template>

<script>
import viewDetailsBox from './view_details_box.vue'
import ImgUpload from "../FileUpload/ImgUpload.vue";
import VideosUpload from "../FileUpload/VideosUpload.vue";
import { 
	post_community_addpost, //发布帖子
	post_community_postthumb, //点赞(帖子)
	post_community_userfollow,  //关注用户
	
	post_community_toppost, //帖子置顶
	post_community_canceltoppost, //取消帖子置顶
	post_community_delpost, //删除帖子
	post_community_postnotinterest, //不感兴趣
	post_community_dislikeuser, //不喜欢该用户
	post_community_postreport, //举报 (帖子)
	post_community_postread, //浏览帖子
} from '@/api/community.js'

export default {
	name: 'PostingModule',
	components: { viewDetailsBox, ImgUpload, VideosUpload },

	props: {
    // Post_List: {
    //  type: Array,
    //  default: []
    // },
    // parent_type: {
    //  type: String,
    //  default: []
    // },
	},
	data() {
		return {
			isSubmitting: true, // 是否正在提交
			userinfo: this.$store.state.userinfo,
			// placeholder: "What is happening?",
			placeholder: this.$t('postsArr.Say_something'),
			post_data: {
				post_type: 1, // //必填 1图文, 2视频
				content: "", //必填
				subjects: [], //['旅游',...]
				pics: [
					{
						height: 0,
						width: 0,
						ios_url: "", //ios端Flve图的地址
						url: "", //安卓端图的地址
						video: "", //ios端Flve图的视频
					},
				], //图片
				videos: [], //视频
				video_cover: "", //视频封面
			},
			rules: {},
			viewDetailsList: {
				pics: [],
				videos: []
			},
			viewDetailsShow: false,
			Loading: false,
			ImgList: [],
			maxImgList: 9,
			PicsFileUpload: false,
			VideosList: [],
			maxVideosList: 1,
			VideosFileUpload: false,
			acceptType:"image/jpeg, image/png, image/webp, image/jpg",
		}
	},

  // 监听
  watch: {
    "$store.state.userinfo": {
      handler: function (newValue, oldValue) {
        this.userinfo = this.$store.state.userinfo
      },
      deep: true
    },
    "Post_List": {
      handler: function (newValue, oldValue) {
        
      },
      deep: true
    },
    "post_data": {
      handler: function (newValue, oldValue) {
		  this.get_empty()
      },
      deep: true
    },
    "ImgList": {
      handler: function (newValue, oldValue) {
		  this.get_empty()
      },
      deep: true
    },
    "VideosList": {
      handler: function (newValue, oldValue) {
		  this.get_empty()
      },
      deep: true
    },
  },

	created () {

	},

	mounted() {
		this.$refs.autoFocusTextarea.focus();  // 自动聚焦
	},

	methods: {
		// handleInput(e) {
		// 	this.post_data.content = e.target.innerText;
		// },
		// clearIfNoInput(e) {
		// 	// 当失去了焦点并且输入为空时，清空输入区域
		// 	if (!e.target.innerText && this.$refs.autoFocusTextarea && this.$refs.autoFocusTextarea.hasFocus) {
		// 		this.post_data.content = '';
		// 		this.showClearMessage = true; // 显示清空消息
		// 	}
		// },
		adjustHeight(event) {
			const textarea = event.target;
			textarea.style.height = 'auto';  // 重置高度
			textarea.style.height = textarea.scrollHeight + 'px';  // 根据内容设置高度
		},
		
		get_empty(){
			let post_data = this.post_data
			if(post_data.content.trim() != '' && (this.ImgList.length > 0 || this.VideosList.length > 0)){
				this.isSubmitting = false
			}else{
				this.isSubmitting = true
			}
		},
	  
    // 点击“话题”按钮插入 #
    tags_fun() {
      const autoFocusTextarea = this.$refs.autoFocusTextarea;
      const selection = window.getSelection();
      const range = selection.getRangeAt(0);
    
      // 获取当前编辑器内的文本内容
      const currentText = autoFocusTextarea.innerText;
    
      // 创建新的#节点
      const span = document.createTextNode("#");
    
      // 将范围设置到文本开头插入#
      range.setStart(autoFocusTextarea, 0);
      range.insertNode(span);
      range.setEnd(autoFocusTextarea, 0);
    
      // 将光标移动到 # 后
      range.setStartAfter(span);
      range.setEndAfter(span);
      selection.removeAllRanges();
      selection.addRange(range);
    },
    
    // 实时处理输入内容
    handleInput() {
      const autoFocusTextarea = this.$refs.autoFocusTextarea;
      const text = autoFocusTextarea.innerText;
    
      // 先按照空格分割文本内容，以便后续处理每个部分是否是话题标签
      const parts = text.split(' ');
      const tags = [];
      const newParts = [];
    
      parts.forEach((part, index) => {
        // 处理话题标签，如果#后没有内容，加空格隔开
        if (part.startsWith('#')) {
          const tag = part.slice(1).trim();
          if (tag) {
            tags.push(tag);
            newParts.push(`<span class="topic">#${tag}</span>`);
          } else {
            // 如果#后无内容，保持原样
            newParts.push(part);
            // 检查下一个#是否需要空格分隔
            if (parts[index + 1] && parts[index + 1].startsWith('#')) {
              newParts.push(' ');  // 在两个#之间插入空格
            }
          }
        } else {
          newParts.push(part);
        }
		  this.post_data.content = text
      });
    
      const html = newParts.join(' ');
    
      // 更新 DOM 的内容
      autoFocusTextarea.innerHTML = html;
    
      // 更新话题标签列表
      this.updateConversation(tags);
    
      // 恢复光标位置
      this.restoreCaretPosition(autoFocusTextarea);
    },
    
    // 更新话题标签列表
    updateConversation(currentTags) {
      // 找出新增的标签
      const addedTags = currentTags.filter((tag) =>!this.post_data.subjects.includes(tag));
      // 找出删除的标签
      const removedTags = this.post_data.subjects.filter((tag) =>!currentTags.includes(tag));
    
      // 更新 subjects 数组
      this.post_data.subjects.push(...addedTags);
      this.post_data.subjects = this.post_data.subjects.filter((tag) =>!removedTags.includes(tag));
    },
    
    // 恢复光标位置
    restoreCaretPosition(element) {
      const selection = window.getSelection();
      selection.selectAllChildren(element);
      selection.collapseToEnd();
    },

    // 提交内容
    submitForm() {
      // const autoFocusTextarea = this.$refs.autoFocusTextarea;
      // const content = autoFocusTextarea.innerText;

      // console.log("提交的内容：", content);
      // console.log("提交的话题标签：", this.post_data.subjects);

      // // 将内容和话题标签提交到后端等操作，此处仅更新 post_data.content
      // this.post_data.content = content;
		
		console.log(this.post_data)
		//图片
		if (this.post_data.post_type == 1) {
		   this.post_data.pics = this.ImgList.map(({width, height, url}) => ({width, height, url}));
			this.post_data.videos = []
			this.post_data.video_cover = ""
		}
		//视频
		if (this.post_data.post_type == 2) {
			let arr = []
			this.VideosList.forEach((item)=>{
				arr.push(item.url)
			})
			this.post_data.videos = arr
			this.post_data.pics = []
			console.log(this.post_data.videos)
		}
		
		this.post_community_addpost()
    },
	
	//回复别人的评论
	post_community_addpost(){
		if(this.Loading){ return }
		this.isSubmitting = true;
		this.Loading = true
		let data = this.post_data
		let obj = {
			post_type: data.post_type, // //必填 1图文, 2视频
			content: data.content, //必填
			// subjects: ["test", "话题", "话题1"], //['旅游',...]
			// pics: [],
			// videos: [],
			// video_cover: "",
		}
		if(data.subjects && data.subjects.length != 0){
			obj.subjects = data.subjects
		}
		
		if(data.post_type == 1){
			if(data.pics && data.pics.length != 0){
				obj.pics = data.pics
			}
			obj.videos = []
			obj.video_cover = ""
		}else if(data.post_type == 2){
			if(data.videos && data.videos.length != 0){
				obj.videos = data.videos
				// if(!data.video_cover){
				// 	return this.$message('video_cover', 'error')
				// }
			}
			// video_cover //后端生成
			// if(data.videos && data.videos.length != 0 && data.video_cover){
			// 	obj.video_cover = data.video_cover
			// }
			obj.pics = []
		}
		
		post_community_addpost(obj)
	   .then((res) => {
			console.log(res)
			if(res.code == 0){
				this.successfully()
			}else{
				this.exception_handling(res, "postreport")
			}
	   })
	   .catch((err) => {
			console.log(err)
			this.exception_handling(err, "postreport")
	   })
	},
	
	//成功处理
	successfully(err){
		this.$message(this.$t('tipsArr.Send_successfully'), 'success')
		let that = this
		setTimeout(()=>{
			that.$emit("operations", 'success')
			that.reset_data()
		}, 500)
	},
	
	//重置数据源
	reset_data(){
		this.post_data = {
			post_type: 1, // //必填 1图文, 2视频
			content: "", //必填
			subjects: [], //['旅游',...]
			pics: [
				{
					height: 0,
					width: 0,
					ios_url: "", //ios端Flve图的地址
					url: "", //安卓端图的地址
					video: "", //ios端Flve图的视频
				},
			], //图片
			videos: [], //视频
			video_cover: "", //视频封面
		}
		this.ImgList = []
		this.VideosList = []
		this.$refs.autoFocusTextarea.innerHTML = '';
	},
	
	//异常处理
	exception_handling(err){
		this.Loading = false
		this.$errorMessage(err)
		// this.$message('err.data.message', 'error')
	},


	set_acceptType(){
		if(this.post_data.post_type == 1){
			this.acceptType = "image/jpeg, image/png, image/webp, image/jpg"
		}else{
			this.acceptType = "video/mp4" 
		}
	},

    // 切换为图片类型
    pics_fun() {
		if(this.ImgList.length >= this.maxImgList){ return }
      this.post_data.post_type = 1
		this.VideosList = [] //清空视频的
		this.post_data.videos = [] //清空视频的
		this.set_acceptType()
		let that = this
		setTimeout((item)=>{
			that.PicsFileUpload = true
			that.VideosFileUpload = false
			that.$refs.PicsUpload.triggerPicsUpload();
		}, 300)
    },

    // 切换为视频类型
    videos_fun() {
		if(this.VideosList.length >= this.maxVideosList){ return }
      this.post_data.post_type = 2
		this.ImgList = [] //清空图片的
		this.post_data.pics = [] //清空图片的
			
		this.set_acceptType()
		let that = this
		setTimeout((item)=>{
			that.PicsFileUpload = false
			that.VideosFileUpload = true
			that.$refs.VideosUpload.triggerPicsUpload();
		}, 300)
    },

    // 查看 粉丝或关注人信息
    check_information(item) {
		console.log(item)
		this.$router.push({
		   name: "user-profile",
		   params: {
		      // routeName: item.user_id,
				nickname: item.nickname,
		      // page: this.listQuery.page,
		   }
		})
    },

    // 验证
    file_url_validate(name) {
      this.$refs.form_base.validateField(name, (val) => {
        if (!val) {
          return true
        } else {
          return false
        }
      })
    },

    // 子组件传值
    // 新建保存的图片
    save_imgs(obj) {
      console.log(obj)
		this.ImgList.push(obj)
      // this.post_data.pics.push(url)
      // this.imgList.push({ url: url })
      // this.file_url_validate('imgs')
    },

    // 新建删除的图片
    remove_imgs(url) {
      console.log(url)
		this.ImgList = this.ImgList.filter((item) => {
		   return item.url!== url;
		});
      console.log(this.ImgList)
      // this.post_data.pics = data
      // this.file_url_validate('imgs')
    },
	 
    // 子组件传值
    // 新建保存的视频
    save_videos(obj) {
      console.log(obj)
		this.VideosList.push(obj)
      // this.post_data.pics.push(url)
      // this.imgList.push({ url: url })
      // this.file_url_validate('imgs')
    },

    // 新建删除的视频
    remove_videos(url) {
      console.log(url)
		this.VideosList = this.VideosList.filter((item) => {
		   return item.url!== url;
		});
      console.log(this.VideosList)
      // this.post_data.pics = data
      // this.file_url_validate('imgs')
    },

    // 查看详情
    view_details(list, type) {
      console.log(list)
      if (type == 'videos') {
        this.viewDetailsList.videos = list
      } else {
        this.viewDetailsList.pics = list
      }
      this.viewDetailsShow = true
    },

    // 查看详情
    view_details(list, type) {
      console.log(list)
      if (type == 'videos') {
        this.viewDetailsList.videos = list
      } else {
        this.viewDetailsList.pics = list
      }
      this.viewDetailsShow = true
    },

    // 更新当前状态
    change_state(item) {
      if (this.parent_type == 'follow') {
        this.change_RightSidebar(item)
      } else if (this.parent_type == 'fans-list') {
        this.change_FanHomePage(item)
      } else if (this.parent_type == 'follow-list') {
        this.change_FollowList(item)
      }
    },

    // 更新当前状态
    change_RightSidebar(item) {
      console.log('change_RightSidebar')
      console.log(item)
    },

    // 更新当前状态
    change_FanHomePage(item) {
      console.log('change_FanHomePage')
      console.log(item)
    },

    // 更新当前状态
    change_FollowList(item) {
      console.log('change_FollowList')
      console.log(item)
    }
  }
}
</script>

<style lang="less" scoped>
  * {
    box-sizing: border-box;
    font-family: Poppins, Poppins;
  }

 .PostingModule-box {
    width: 100%;
    background-color: #ffffff;
    border-radius: 8px;
    margin-top: 10px;
    padding: 10px 10px;
  }
	.avatar{
      display: flex;
      justify-content: center;
      align-items: center;
	}
	.el-icon-s-custom {
      height: 40px;
		width: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
	}
 .list_box {
   .information_big_box {
      display: flex;
     .information_box {
        display: flex;
        width: calc(100% - 0px);
       .avatar {
          width: 40px;
          height: 40px;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #505050;
          border-radius: 50%;
          overflow: hidden;
          cursor: pointer;
          img {
            width: 100%;
            height: 100%;
          }
         .el-icon-s-custom {
            height: 40px;
				width: 40px;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            border: 1px #f5f5f5 solid;
            border-radius: 50%;
            font-size: 20px;
            color: #999;
          }
        }
      }
    }
   .pics_and_videos {
      margin-top: 5px;

     .file_box {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
       .file_item {
          width: 80px;
          height: 80px;
          border-radius: 8px;
          margin-right: 10px;
          margin-top: 10px;
          overflow: hidden;
          cursor: pointer;
          &:last-child {
            margin-right: 0px;
          }
          video,
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
       .add_file_item {
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 30px;
          color: #505050;
          background-color: #f5f5f5;
          border: 1px #f1f1f1 solid;
        }
      }
    }
   .content_box {
      width: calc(100% - 50px);
      margin-top: 10px;
      margin-left: 10px;
      display: flex;
      flex-direction: column;

     .auto-resize-textarea {
        width: 100%;
        min-height: 20px;
        resize: none;
        /* 禁止用户调整大小 */
        border: none;
        outline: none;
        font-size: 14px;
        line-height: 1.5;
        padding: 0px;
        box-sizing: border-box;
        overflow: hidden;
        border-radius: 4px;
        background: transparent;
      }
     .auto-resize-textarea::placeholder {
        color: #aaa;
      }
    }
   .topic_of_subjects {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      margin-top: 5px;
     .subjects {
        margin-top: 5px;
        color: #06f;
        border: 1px #06f solid;
        /* color: #2094FA; */
        /* border: 1px #2094FA solid; */
        border-radius: 4px;
        margin-right: 5px;
        font-size: 10px;
        padding: 2px 8px;
        &:last-child {
          margin-right: 0px;
        }
      }
    }
  }
  
  
   .bottom_box_big{
     width: 100%;
     padding: 10px 0px;
     border-top: 1px solid #CFDADE;
     margin-top: 15px;
   }
  .PostingModule_bottom_box {
     width: 100%;
     margin-top: 10px;
     display: flex;
     justify-content: space-between;
    .bottom_box_icon {
			display: flex;
			width: 50%;
     }
    .icon_box {
       margin-right: 24px;
       width: 34px;
		 height: 34px;
       display: flex;
       align-items: center;
       &:last-child {
         margin-right: 0px;
       }
      .icon_box_img {
         width: 34px;
			height: 34px;
         font-size: 16px;
         /* height: 12px; */
       }
      .icon_box_text {
         margin-left: 7px;
         font-weight: 400;
         font-size: 12px;
         color: #3C3C3C;
         line-height: 12px;
         text-align: left;
         font-style: normal;
         text-transform: none;
       }
     }
    .btn_box {
		width: 50%;
		display: flex;
		justify-content: flex-end;
	 }
    .post_btn {
       height: 36px;
       padding: 0px 10px;
       display: flex;
       justify-content: center;
       align-items: center;
       min-width: 100px;
       background: #06f;
      //  background: #2094FA;
       border-radius: 999px 999px 999px 999px;
       font-weight: 400;
       font-size: 12px;
       color: #FFFFFF;
       line-height: 14px;
       text-align: center;
       font-style: normal;
       text-transform: none;
  	  border: 0;
     }
  	button:disabled{
  		background-color: #999999;
  	}
   }

	.custom-input {
	  /* border: 1px solid #ccc; */
	  padding: 0px;
	  min-height: 45px;
	  width: 100%;
	  font-size: 14px;
	  outline: none;
	  white-space: pre-wrap;
	  .topic{
      color: #06f;
		  // color: #2094FA;
	  }
	}
	
	.auto-expand-textarea {
		width: 100%;
		overflow: hidden;
		resize: none;
		padding: 2px 5px;
		border: 0px;
		border: 0px solid #f5f5f5;
		border-radius: 4px;
		box-sizing: border-box;
		font-size: 14px;
		line-height: 1.5;
		min-height: 50px; /* 初始高度 */
		max-height: 400px; /* 设置一个最大高度 */
	}
	
	.pointer{
		cursor: pointer;
	}
	.no_drop{
		cursor: no-drop;
	}
		

	</style>
